import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/manutencao`

    const headers = {responseType: "arraybuffer"}

    return {
        solicitacao(id) {

            return repository.get(`${baseUrl}/solicitacao/${id}`, headers)
        },
        gerenciamento(id) {

            return repository.get(`${baseUrl}/gerenciamento/${id}`, headers)
        },
        relatorioSolicitacoes(queryParms) {

            return repository.get(`${baseUrl}/relatorio-solicitacoes?${urlUtil.serialize(queryParms)}`, headers)
        }
    }
}